module.exports = __webpack_public_path__ + "img/02.cec919da.jpg";